// extracted by mini-css-extract-plugin
module.exports =  {"banner":"_373a3719ba--banner--bdTjE","title":"_373a3719ba--title--wrtEt","icon":"_373a3719ba--icon--HQHI0"};